module.exports = __webpack_public_path__ + "04_glasses_black.ae05ba75.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/04_glasses_black.png
// module id = uG0T
// module chunks = 0